// @owners { team: patients-team }
import { Body, BulletedList, BulletedListItem } from '@alto/design-system';
import React from 'react';

export const CouponTerms = () => {
  // TODO: Either hardcode terms and conditions on the FE or fetch from BE
  // these are the terms and conditions for Nurtec
  return (
    <Body>
      <BulletedList>
        <BulletedListItem>I am 18 years of age or older.</BulletedListItem>
        <BulletedListItem>I currently live in the United States or Puerto Rico.</BulletedListItem>
        <BulletedListItem>
          I do not have commercial insurance from any federal healthcare program (including Medicare, Medicaid, TRICARE
          or any other state or federal medical pharmaceutical benefit program or pharmaceutical assistance program).
        </BulletedListItem>
        <BulletedListItem>
          I am not over 65 years of age and retired, and if applicable, neither is my partner.
        </BulletedListItem>
        <BulletedListItem>
          I do not receive Social Security Disability or any other social security administration benefit.
        </BulletedListItem>
        <BulletedListItem>I do not receive health insurance through the military.</BulletedListItem>
        <BulletedListItem>
          I have reviewed and agree to the Terms and Conditions and attest that I am eligible to participate in this
          program.
        </BulletedListItem>
      </BulletedList>
    </Body>
  );
};
